/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesFleetDtosEndVehicleTripRequest,
  FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto,
  FacilityFlowCoreModulesFleetDtosMyVehicleTripsDto,
  FacilityFlowCoreModulesFleetDtosParkVehicleRequest,
  FacilityFlowCoreModulesFleetDtosStartVehicleTripRequest,
  FacilityFlowCoreModulesFleetDtosTripDetailsSuggestionDto,
  FacilityFlowCoreModulesFleetDtosUnparkedTripDto,
  GetApiV1MeVehicleTripsParams,
  GetApiV1MeVehicleTripsSuggestionParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getMeVehicleTrips = () => {
/**
 * @summary The running trip or ride, if any, and whether the tenant offers private trips.
 */
const getApiV1MeVehicleTripsCurrent = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>(
      {url: `/api/v1/me/vehicle-trips/current`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Destination and purpose the own duty plan suggests for a business trip departing at
at (UTC; now without): the planned task nearest to the departure, else
"laut Dienstplan"; and the start — where the employee or vehicleId last
arrived today, else the planned task before, else the company. Prefills the start dialog;
the employee can change it.
 */
const getApiV1MeVehicleTripsSuggestion = (
    params?: GetApiV1MeVehicleTripsSuggestionParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosTripDetailsSuggestionDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosTripDetailsSuggestionDto>(
      {url: `/api/v1/me/vehicle-trips/suggestion`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary The own trips and rides of the local days from to to (at most 366 days).
 */
const getApiV1MeVehicleTrips = (
    params?: GetApiV1MeVehicleTripsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripsDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripsDto>(
      {url: `/api/v1/me/vehicle-trips`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Starts a trip as driver or a ride as passenger, now — being clocked in is not required.
 */
const postApiV1MeVehicleTripsStart = (
    facilityFlowCoreModulesFleetDtosStartVehicleTripRequest: FacilityFlowCoreModulesFleetDtosStartVehicleTripRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>(
      {url: `/api/v1/me/vehicle-trips/start`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosStartVehicleTripRequest
    },
      options);
    }
  /**
 * @summary Ends the own trip — or the ride, for a passenger — now.
 */
const postApiV1MeVehicleTripsCurrentEnd = (
    facilityFlowCoreModulesFleetDtosEndVehicleTripRequest: FacilityFlowCoreModulesFleetDtosEndVehicleTripRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosMyVehicleTripStatusDto>(
      {url: `/api/v1/me/vehicle-trips/current/end`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosEndVehicleTripRequest
    },
      options);
    }
  /**
 * @summary The trips the employee still has to park, oldest first.
 */
const getApiV1MeVehicleTripsUnparked = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesFleetDtosUnparkedTripDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesFleetDtosUnparkedTripDto[]>(
      {url: `/api/v1/me/vehicle-trips/unparked`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Parks the vehicle: enters the end reading left out when ending the trip — only once.
 */
const postApiV1MeVehicleTripsEntryIdPark = (
    entryId: string,
    facilityFlowCoreModulesFleetDtosParkVehicleRequest: FacilityFlowCoreModulesFleetDtosParkVehicleRequest,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/me/vehicle-trips/${entryId}/park`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesFleetDtosParkVehicleRequest
    },
      options);
    }
  return {getApiV1MeVehicleTripsCurrent,getApiV1MeVehicleTripsSuggestion,getApiV1MeVehicleTrips,postApiV1MeVehicleTripsStart,postApiV1MeVehicleTripsCurrentEnd,getApiV1MeVehicleTripsUnparked,postApiV1MeVehicleTripsEntryIdPark}};
export type GetApiV1MeVehicleTripsCurrentResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['getApiV1MeVehicleTripsCurrent']>>>
export type GetApiV1MeVehicleTripsSuggestionResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['getApiV1MeVehicleTripsSuggestion']>>>
export type GetApiV1MeVehicleTripsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['getApiV1MeVehicleTrips']>>>
export type PostApiV1MeVehicleTripsStartResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['postApiV1MeVehicleTripsStart']>>>
export type PostApiV1MeVehicleTripsCurrentEndResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['postApiV1MeVehicleTripsCurrentEnd']>>>
export type GetApiV1MeVehicleTripsUnparkedResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['getApiV1MeVehicleTripsUnparked']>>>
export type PostApiV1MeVehicleTripsEntryIdParkResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getMeVehicleTrips>['postApiV1MeVehicleTripsEntryIdPark']>>>
